import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
	align-items: center;
	justify-content: flex-start;
	background-color: ${color.interface.white};
	padding: 1.5rem;
	border-radius: 5px;
	overflow: hidden;
`;
